var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.computedCategories
    ? _c(
        "div",
        {
          staticClass: "grid grid-cols-1",
          class:
            _vm.computedCategories.length === 1
              ? "gap-x-[32px]"
              : "lg:grid-cols-2 gap-x-[100px]"
        },
        _vm._l(_vm.computedCategories, function(category) {
          return _c(
            "div",
            { key: category.id },
            [
              _c("div", {
                staticClass: "text-30 mb-24",
                domProps: { innerHTML: _vm._s(category.name) }
              }),
              _vm._v(" "),
              _vm._l(category.faqs, function(faq) {
                return _c(
                  "a",
                  {
                    key: faq.id,
                    staticClass:
                      "tool text-orange flex justify-between group text-20 pb-16 mb-16 border-b border-gray-200",
                    attrs: {
                      "data-tool-category": category.name
                        .toLowerCase()
                        .replace("amp;", ""),
                      href: faq.link
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(faq.title.rendered) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fas fa-chevron-right text-14 text-black group-hover:mr-[-8px] transition-all"
                    })
                  ]
                )
              })
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }